/* eslint-disable */
export default {
  saveLog: 'Opslaan',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
